$(document).ready(function(){

 // Add smooth scrolling to all links
  $(".pferdegold-blackweek-anchor a").on('click', function(event) {

    if (this.hash !== "") {
      event.preventDefault();

      var hash = this.hash;

      $('html, body').animate({
        scrollTop: $(hash).offset().top - 150
      }, 800, function(){

        
      });
    } 
});
});




